import moment from "moment";
import type { Notification } from "../../types";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Button } from "@/components/ui/button";
import { useHistory } from "react-router-dom";

dayjs.extend(relativeTime);

interface TaskCreatedProps {
  notification: Notification;
  updateNotificationStatus?: (params: {
    notification?: any;
    redirect?: boolean;
    otherSwitch?: boolean;
  }) => void;
}

export const TaskCreated = ({
  notification,
  updateNotificationStatus,
}: TaskCreatedProps) => {
  let history = useHistory();

  const handleMarkAsRead = () => {
    if (updateNotificationStatus) {
      updateNotificationStatus({
        notification: notification,
      });
    }
  };

  const handleViewTask = () => {
    history.push(`/tasks`);
    if (updateNotificationStatus) {
      updateNotificationStatus({
        notification: notification,
        redirect: true,
      });
    }
  };

  return (
    <div className="bg-primary/10 p-2 rounded-md w-full relative">
      <h2 className="text-sm font-medium">New Task Created</h2>
      <p className="text-xs text-muted-foreground mt-1">
        {notification.notification_message ||
          notification.content ||
          "A new task has been created for the lead"}
      </p>
      <time
        className="text-xs absolute top-2 right-2"
        dateTime={notification.notification_time}
      >
        {dayjs(notification.notification_time).fromNow()}
      </time>
      <div className="mt-2">
        {notification.task_id && (
          <Button size="sm" onClick={handleViewTask}>
            View Task
          </Button>
        )}
        {!notification.read_status && (
          <Button
            size="sm"
            variant="outline"
            className="ml-2"
            onClick={handleMarkAsRead}
          >
            Mark as read
          </Button>
        )}
      </div>
    </div>
  );
};
